import type { FaireProductEntity } from "../../entity_types/product";

export const p_4s7rucz3t3: FaireProductEntity = {
  token: "p_4s7rucz3t3",
  type: "product",
  name: "Golf Baby- Board Book",
  brandToken: "b_9vx4sf6cb2",
  brandName: "Left Hand Book House",
  imageUrl:
    "https://cdn.faire.com/fastly/e6241795dd50fd60d7f57203de149c24335e501b2e2c6afe44885cab721af085.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/481da4afc6dcc9b62f11b347ccec9a179a1f6e089e27272fc02b6ae52f983a92.jpeg",
    "https://cdn.faire.com/fastly/89b443b1055bb7ea121954e647e10c7695f47722cacae2b475c808aed65223d1.jpeg",
    "https://cdn.faire.com/fastly/a5326563ea697cd8707758e35535d9af317cdf845e037a866de96294548c0dd9.jpeg",
    "https://cdn.faire.com/fastly/0c831101b728fd036246a291bcb04588fac997bd09c5f590127527300a71af15.jpeg",
    "https://cdn.faire.com/fastly/07f5c16c70ea113d38f67b83f3afb2ff84a5bd6f42ed88297f2cfa89d07ebe24.jpeg",
    "https://cdn.faire.com/fastly/39f530d30ae8f77b3ca13d60399396b680a04111690129d485afc89416f6478c.jpeg",
    "https://cdn.faire.com/fastly/54bd0e56a7f06b853d38f0586e14ae9fdb53525764f428bdd5e20970aaf4af59.png",
  ],
  priceDollars: 5.49,
  description:
    'Time to tee off, baby! Introduce your little one to the world of golf with our Golf Baby board book. &nbsp;Every Let\'s Go! Baby book contains clear and simple images to help tots get acquainted with your favorite pastime. Get your baby swinging with the Golf Baby board book; featuring adorable illustrations of essential golf gear like a golf cart, driver, and bag, making learning the basics as fun and almost as easy as a day on the green!\n\nAges 0-4\n\nDetails\n\n * 5.5"x5.5"x.5" Board Book \n * triple layered pages for extra durability \n * matte finish \n * 16 pages \n * written by Danielle Wilson \n * illustrated by Ericka Singson \n * designed in USA\n * printed in China ',
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:11.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
